// src/subscreens/superadmin/ratings/RatingsPage.jsx

import React, { useState, useEffect } from 'react';
import { FiMoreVertical, FiEye, FiTrash2, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaStar } from 'react-icons/fa';
import { Dropdown, Modal } from 'react-bootstrap';
import AppPagination from "../../../components/general/pagination/Pagination.js";
import '../../../assets/css/superadmin/ratingreview/RatingReviews.css';
import MasterLayout from '../../../layout/superadmin/MasterLayout.js';

// ─────────────────────────────────────────────
// SKELETON COMPONENTS
// ─────────────────────────────────────────────

const SkeletonTabs = () => (
  <div className="rt-skeleton-tabs">
    {[1, 2, 3].map((i) => (
      <div key={i} className="rt-skeleton rt-skeleton-tab" />
    ))}
  </div>
);

const SkeletonTable = () => (
  <div className="rt-skeleton-table-wrapper">
    {[1, 2, 3, 4, 5].map((i) => (
      <div key={i} className="rt-skeleton-table-row">
        {/* Name cell */}
        <div className="rt-skeleton rt-skeleton-avatar" />
        <div className="rt-skeleton rt-skeleton-name" />
        {/* Category badge */}
        <div className="rt-skeleton rt-skeleton-badge" />
        {/* Total reviews */}
        <div className="rt-skeleton rt-skeleton-cell rt-skeleton-cell-sm" />
        {/* Stars */}
        <div className="rt-skeleton-stars">
          {[1,2,3,4,5].map((s) => (
            <div key={s} className="rt-skeleton rt-skeleton-star" />
          ))}
          <div className="rt-skeleton rt-skeleton-cell rt-skeleton-cell-sm" style={{ marginLeft: 6 }} />
        </div>
        {/* Last feedback */}
        <div className="rt-skeleton rt-skeleton-cell rt-skeleton-cell-lg" />
        {/* Action */}
        <div className="rt-skeleton rt-skeleton-action" />
      </div>
    ))}
  </div>
);

// ═══════════════════════════════════════════════
// COMPONENT
// ═══════════════════════════════════════════════

const RatingsPage = () => {

  // ── Loading state ──
  const [isLoading, setIsLoading] = useState(true);

  // ── ReviewTable States ──
  const [activeTab,        setActiveTab]        = useState('all');
  const [selectedReview,   setSelectedReview]   = useState(null);
  const [showDetailModal,  setShowDetailModal]  = useState(false);
  const [currentPage,      setCurrentPage]      = useState(1);
  const [reviews, setReviews] = useState([
    { id: 1, name: 'AgriRix Solutions',      avatar: 'https://i.pravatar.cc/150?img=1',  category: 'SHOP',       totalReviews: 1262, avgRating: 4.8, lastFeedback: 'Excellent response time and...', type: 'shop'       },
    { id: 2, name: 'Robert Chan',             avatar: 'https://i.pravatar.cc/150?img=12', category: 'INDIVIDUAL', totalReviews: 415,  avgRating: 5.0, lastFeedback: 'Robert knows every combination...', type: 'individual' },
    { id: 3, name: 'GreenField Maintenance',  avatar: 'https://i.pravatar.cc/150?img=5',  category: 'SHOP',       totalReviews: 892,  avgRating: 4.1, lastFeedback: 'Good service but the wait ti...', type: 'shop'       },
    { id: 4, name: 'Sarah Miller',            avatar: 'https://i.pravatar.cc/150?img=47', category: 'INDIVIDUAL', totalReviews: 210,  avgRating: 4.7, lastFeedback: 'Fixed my harvester electrical...', type: 'individual' },
  ]);

  // ── TopRatedMechanics Data ──
  const mechanics = [
    { name: 'Robert Chan',   rating: 4.96, color: '#FDB714' },
    { name: 'Sarah Miller',  rating: 4.92, color: '#FFD700' },
    { name: 'John Douglas',  rating: 4.89, color: '#FFA500' },
    { name: 'Alex King',     rating: 4.85, color: '#FF8C00' },
    { name: 'Maria Garcia',  rating: 4.79, color: '#FF6347' },
  ];
  const mechAvgRating  = 4.9;
  const mechRatingChange = '+1.8%';

  // ── TopRatedShops Data ──
  const shops = [
    { name: 'GreenField',   rating: 4.8 },
    { name: 'PowerTractor', rating: 4.7 },
    { name: 'FarmMech',     rating: 4.6 },
    { name: 'AgriRx',       rating: 4.5 },
    { name: 'BioReaper',    rating: 4.4 },
  ];
  const shopAvgRating   = 4.8;
  const shopRatingChange = '+2.4%';

  // ── Simulate data fetch ──
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  // ── ReviewTable Helpers ──
  const handleView = (review) => { setSelectedReview(review); setShowDetailModal(true); };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this review?')) {
      setReviews(reviews.filter(r => r.id !== id));
    }
  };

  const filteredReviews = activeTab === 'all'
    ? reviews
    : reviews.filter(r => r.type === activeTab);

  const itemsPerPage      = 5;
  const totalPages        = Math.ceil(filteredReviews.length / itemsPerPage);
  const paginatedReviews  = filteredReviews.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) => (
      <FaStar key={i} className={i < Math.floor(rating) ? 'rt-star filled' : 'rt-star'} />
    ));

  // ================================================================
  // RETURN
  // ================================================================
  return (
    <MasterLayout>
    <div>

      {/* ════════════════════════════════
          TOP RATED MECHANICS
      ════════════════════════════════ */}
      {/* <div className="trm-container">
        ...
      </div> */}

      {/* ════════════════════════════════
          TOP RATED SHOPS
      ════════════════════════════════ */}
      {/* <div className="trs-container">
        ...
      </div> */}

      {/* ════════════════════════════════
          REVIEWS TABLE
      ════════════════════════════════ */}
      <div className="rt-container">

        {/* ════════════════════════════════
            SKELETON or CONTENT
        ════════════════════════════════ */}
        {isLoading ? (
          <>
            <SkeletonTabs />
            <SkeletonTable />
          </>
        ) : (
          <>
            {/* Tabs */}
            <div className="rt-tabs">
              {[
                { key: 'all',        label: 'All Reviews'           },
                { key: 'shop',       label: 'rental Shops'          },
                { key: 'individual', label: 'Individual Mechanics'  },
              ].map(tab => (
                <button
                  key={tab.key}
                  className={`rt-tab ${activeTab === tab.key ? 'active' : ''}`}
                  onClick={() => { setActiveTab(tab.key); setCurrentPage(1); }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Table */}
            <div className="rt-table-wrapper">
              <table className="rt-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Total Reviews</th>
                    <th>Average Rating</th>
                    <th>Last Feedback</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedReviews.map((review) => (
                    <tr key={review.id}>
                      <td>
                        <div className="rt-name-cell">
                          <img src={review.avatar} alt={review.name} className="rt-avatar" />
                          <span className="rt-name">{review.name}</span>
                        </div>
                      </td>
                      <td>
                        <span className={`rt-category-badge ${review.category.toLowerCase()}`}>
                          {review.category}
                        </span>
                      </td>
                      <td className="rt-reviews">{review.totalReviews}</td>
                      <td>
                        <div className="rt-rating">
                          <div className="rt-stars">{renderStars(review.avgRating)}</div>
                          <span className="rt-rating-value">{review.avgRating}</span>
                        </div>
                      </td>
                      <td className="rt-feedback">{review.lastFeedback}</td>
                      <td>
                        <Dropdown align="end">
                          <Dropdown.Toggle className="rt-action-toggle">
                            <FiMoreVertical size={18} />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="rt-action-menu">
                            <Dropdown.Item className="rt-action-item" onClick={() => handleView(review)}>
                              <FiEye size={16} /><span>View</span>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item className="rt-action-item delete" onClick={() => handleDelete(review.id)}>
                              <FiTrash2 size={16} /><span>Delete</span>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {filteredReviews.length === 0 && (
                <div className="rt-no-data"><p>No reviews found</p></div>
              )}
            </div>

            {/* Pagination */}
            <AppPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={filteredReviews.length}
              itemsPerPage={itemsPerPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </>
        )}

      </div>

      {/* ════════════════════════════════
          DETAIL MODAL
      ════════════════════════════════ */}
      {selectedReview && (
        <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered size="lg" className="rt-detail-modal">
          <Modal.Header closeButton className="rt-modal-header">
            <Modal.Title className="rt-modal-title">Review Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="rt-modal-body">
            <div className="rt-modal-profile">
              <img src={selectedReview.avatar} alt={selectedReview.name} className="rt-modal-avatar" />
              <div className="rt-modal-info">
                <h4 className="rt-modal-name">{selectedReview.name}</h4>
                <span className={`rt-category-badge ${selectedReview.category.toLowerCase()}`}>
                  {selectedReview.category}
                </span>
              </div>
            </div>
            <div className="rt-modal-stats">
              <div className="rt-modal-stat">
                <span className="rt-modal-stat-label">Total Reviews</span>
                <span className="rt-modal-stat-value">{selectedReview.totalReviews}</span>
              </div>
              <div className="rt-modal-stat">
                <span className="rt-modal-stat-label">Average Rating</span>
                <div className="rt-modal-stat-value">
                  {renderStars(selectedReview.avgRating)}
                  <span>{selectedReview.avgRating}</span>
                </div>
              </div>
            </div>
            <div className="rt-modal-feedback">
              <h5 className="rt-modal-feedback-title">Latest Feedback</h5>
              <p className="rt-modal-feedback-text">{selectedReview.lastFeedback}</p>
            </div>
          </Modal.Body>
          <Modal.Footer className="rt-modal-footer">
            <button className="rt-modal-btn secondary" onClick={() => setShowDetailModal(false)}>Close</button>
          </Modal.Footer>
        </Modal>
      )}

    </div>
    </MasterLayout>
  );
};

export default RatingsPage;